import React, { Component } from "react";

import "./CsListItem.css";
import { RecordVoiceOver, Note, Save, WhatsApp } from "@mui/icons-material"
import { Chip, TextField, Tooltip, CircularProgress, Paper, Button, ButtonGroup } from "@mui/material";
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from "axios";
import moment from "moment";

class CsContactListItem extends Component {
    state = {
        isSavingNote: false,
        isEditingNote: false,
        isStarting: false,
        note: ""
    };

  getColor = () => {
    var randomColor = Math.floor(Math.random()*16777215).toString(16);
    return "#"+randomColor;
  }

  handleNote = (event) => {
    this.setState({ note: event.target.value });
  };

  handleSetHelpState = (conversation, helpState) => {
    if (helpState === "SOLVING") {
      this.setState({ isStarting: true });
    }

    let params = {
      userId: Global.get().user.id,
      contactId: conversation.contactId,
      helpState: helpState,
      archived: false,
      csId: Global.get().user.id,
      csName: Global.get().user.name
    };
    
    console.log("PARAMS_SET_CS_HELP", params);
    console.log("HEADER", Api.getRequestHeader());
    axios
      .post(Api.setCsHelp(), params, Api.getRequestHeader())
      .then((response) => {
        console.log("SETCSHELP : ", response.data);

        if(helpState === "SOLVING"){
            const afterStarted = (ticket) => {
                conversation.csHelpState = helpState;
                if (ticket) {
                    conversation.ticketStatus = ticket.status;
                    conversation.ticketNumber = ticket.ticket_number || conversation.ticketNumber;
                    conversation.queueLabel = ticket.queue_label || conversation.queueLabel;
                }

                if (typeof this.props.reloadCsHelpList === 'function') {
                    this.props.reloadCsHelpList();
                }

                if (typeof this.props.onCustomerStarted === 'function') {
                    this.props.onCustomerStarted(conversation);
                }

                if (typeof this.props.onOpenChat === 'function') {
                    this.props.onOpenChat(conversation);
                }
            };

            // CS Ticketing (PRD v1.3.0): kalau customer ini punya tiket aktif,
            // panggil endpoint take untuk pindahkan tiket ke `sedang_ditangani`
            // dan trigger HSM "Mohon ditunggu ticket anda sedang kami tangani...".
            if (conversation.ticketId) {
                axios
                    .post(Api.csTicketTake(conversation.ticketId), {}, Api.getRequestHeader())
                    .then((resp) => {
                        console.log("TICKET_TAKE ok:", resp.data);
                        afterStarted(resp.data?.data?.ticket);
                    })
                    .catch((err) => {
                        console.warn("TICKET_TAKE failed:", err?.message);
                        if (typeof this.props.showSnackBar === 'function') {
                            this.props.showSnackBar("Gagal mengubah status tiket menjadi sedang dilayani");
                        }
                    })
                    .finally(() => {
                        this.setState({ isStarting: false });
                    });
            } else {
                afterStarted();
                this.setState({ isStarting: false });
            }
        } else {
            if (typeof this.props.reloadCsHelpList === 'function') {
                this.props.reloadCsHelpList();
            }
            this.setState({ isStarting: false });
        }

      })
      .catch((error) => {
        this.setState({ errorMessage: error.message, isStarting: false });
        console.error("There was an error!", error);
      });
  }

  handleSaveNote = (conversation, note) => {

    this.setState({isSavingNote: true}, () => {
      let params = {
        userId: Global.get().user.id,
        userName: Global.get().user.name,
        contactId: conversation.contactId,
        note: note
      };
      
      axios
        .post(Api.csSaveNote(), params, Api.getRequestHeader())
        .then((response) => {
          console.log("SAVECSNOTE : ", response.data);
          
          this.setState({isSavingNote: false, isEditingNote: false}, ()=>{
              this.props.onUpdateNote(conversation, note);
          });
          
        })
        .catch((error) => {
          this.setState({ errorMessage: error.message });
          console.error("There was an error!", error);
        });
      });
  }

    handleToggleShowNoteInput = () => {
        let showState = this.state.isEditingNote;
        this.setState({isEditingNote: !showState});
    }

  componentDidMount() {
    this.setState({note: this.props.data.csNote});
    // shave(".conversation-snippet", 25);
  }

  render() {
    const { fromName, text, fromNumber, unreadCounter, assignToUserName, csHelpState, showButton, csNote, lastWaCsLog, contactLabel, firstContactAssignedToName, csCreatedAt, csName, queueLabel, ticketNumber, ticketStatus} = this.props.data;

    const assignedName = assignToUserName !== null && assignToUserName !== undefined && assignToUserName.length > 0 ? assignToUserName : firstContactAssignedToName;
    const hasLabel = contactLabel !== undefined && contactLabel !== null && contactLabel.length > 0;
    const hasCsNote = lastWaCsLog !== undefined && lastWaCsLog !== null && csNote !== undefined;

    return (
      <Paper elevation={0} className={this.getListItemClasses()} style={{cursor: "default"}}>
        <div className="cli-row">
          <div className="cli-content">
            {/* Baris 1: nama customer + nomor antrian tiket */}
            <div className="cli-line cli-line-top">
              <span className="cli-name">{fromName}</span>
              {queueLabel && (
                <Tooltip title={ticketNumber || "Nomor Ticket"}>
                  <span className="cli-queue-label" style={{color: ticketStatus === "sedang_ditangani" ? "#2e7d32" : "#c62828"}}>
                    {queueLabel}
                  </span>
                </Tooltip>
              )}
            </div>

            {ticketNumber && (
              <div className="cli-ticket-number">
                {ticketNumber}
                {ticketStatus === "sedang_ditangani" && (
                  <span className="cli-ticket-status">SEDANG DITANGANI</span>
                )}
              </div>
            )}

            {/* Baris 2: pesan terakhir + unread badge */}
            <div className="cli-line">
              <span className="cli-snippet">{text}</span>
              {unreadCounter > 0 && <span className="cli-unread">{unreadCounter}</span>}
            </div>

            {/* Baris tags: nomor WA + PIC + label */}
            <div className="cli-tags">
              <span className="cli-phone">{Global.maskPhoneNumber(fromNumber)}</span>
              <span className="cli-assigned"><RecordVoiceOver sx={{ fontSize: 13 }} /> {assignedName}</span>
              {hasLabel && (
                <span className={Global.getLabelClasses(contactLabel)} style={{fontSize: "9px"}}>{contactLabel}</span>
              )}
            </div>

            {/* Footer: CS penanggung jawab + waktu masuk */}
            <div className="cli-footer">
              <span>CS : {csName}</span>
              <span className="cli-footer-time">Masuk CS : {moment(csCreatedAt).tz("asia/jakarta").format("DD-MM-YYYY HH:mm:ss")}</span>
            </div>

            {/* Tombol aksi CS */}
            <div className="cli-cs-action">
              <ButtonGroup fullWidth size="small" aria-label="Small button group">
                {showButton === true && csHelpState === "OPEN" && (
                  <Tooltip title="Klik untuk memulai sesi bantuan">
                    <Button color="error" size="small" variant="contained" disabled={this.state.isStarting} onClick={() => {this.handleSetHelpState(this.props.data, "SOLVING")}}>
                      {this.state.isStarting ? "Starting..." : "Start"}
                    </Button>
                  </Tooltip>
                )}

                {showButton === true && csHelpState === "SOLVING" && (
                  <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                    <Button color="warning" size="small" variant="contained" onClick={() => {this.handleSetHelpState(this.props.data, "OFF")}}>
                      Finish
                    </Button>
                  </Tooltip>
                )}

                {showButton === true && csHelpState === "SOLVED" && (
                  Global.get().admin === true || Global.isCustomerServiceSpv() || Global.isCustomerService() ? (
                    <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                      <Button color="warning" size="small" variant="contained" onClick={() => {this.handleSetHelpState(this.props.data, "OFF")}}>
                        Finish
                      </Button>
                    </Tooltip>
                  ) : (
                    <Tooltip title={"Akhiri sesi bantuan untuk customer ini, customer akan hilang dari list ini"}>
                      <Button color="warning" size="small" variant="contained" disabled>
                        Finish
                      </Button>
                    </Tooltip>
                  )
                )}

                <Tooltip title={csHelpState === "OPEN" ? "Klik tombol MULAI untuk terlebih dahulu" : "Buka halaman chat"}>
                  <Button color="primary" variant="contained" key="two" disabled={csHelpState === "OPEN"}
                      onClick={() => {this.props.onOpenChat(this.props.data);}}>
                    <WhatsApp style={{width: 17}} /> &nbsp;
                    Open Chat
                  </Button>
                </Tooltip>
              </ButtonGroup>
            </div>

            {/* Catatan CS */}
            {this.state.isEditingNote ? (
              <div className="cli-note-row">
                <TextField
                  className="cli-note-input"
                  onChange={this.handleNote}
                  multiline
                  label="Catatan"
                  type="text"
                  value={hasCsNote ? this.state.note : ""}
                  id={"note" + fromNumber}
                  variant="outlined"
                  size="small"
                />
                {this.state.isSavingNote ? (
                  <CircularProgress size={28} />
                ) : (
                  <Tooltip title="Simpan note">
                    <Button variant="contained" color="warning" size="small" sx={{ minWidth: 0, px: 1 }} onClick={() => {this.handleSaveNote(this.props.data, this.state.note)}}>
                      <Save fontSize="small" />
                    </Button>
                  </Tooltip>
                )}
              </div>
            ) : hasCsNote && (
              <Tooltip title="Catatan CS">
                <Chip
                  icon={<Note />}
                  label={csNote}
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1 }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      </Paper>
    );
  }

  getListItemClasses() {
    let classes = "conversation-list-item";
    if (this.props.data.selected === true) {
      classes += " selected";
    }
    return classes;
  }
}

export default CsContactListItem;
